import React from "react";
import PropTypes from "prop-types";
import { Modal } from "components/Modal";
import { Table } from "components/Table";
import { Tooltip } from "components/Tooltip";
import { CoinHandIcon, HelpIconGrey } from "assets/icons";
import { columns } from "./columns";
import {
  HeaderContent,
  IconWrapper,
  SummarySection,
  HoldingsSection,
  HoldingsTitle,
  Divider,
  TooltipText,
} from "./AllHoldingsModal.styles";
import { Text } from "style/v2/components/Typography";

const ALL_HOLDINGS_TOOLTIP = (
  <>
    <TooltipText>
      Every asset this strategy holds or has ever held — not just the largest
      positions shown in Top Holdings above.
    </TooltipText>
    <TooltipText>
      Share price and 1-year performance reflect the latest available market
      data.
    </TooltipText>
  </>
);

const AllHoldingsModal = ({ isOpen, onClose, holdings }) => {
  const holdingsData = holdings || [];
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      heading={
        <HeaderContent>
          <IconWrapper>
            <img src={CoinHandIcon} alt="Holdings" width={24} height={24} />
          </IconWrapper>
          <div>
            <Text variant="sectionHeading" weight="500" as="h2" mb="0">
              All holdings
            </Text>
            <Text variant="body" color="tertiary">
              Summary of the compositions of this strategy
            </Text>
          </div>
        </HeaderContent>
      }
    >
      <SummarySection>
        <Text variant="cardHeading" as="h3" mb="8px">
          Summary
        </Text>
        <Text variant="body" color="muted">
          This strategy primarily focuses on industries such as technology and
          health technology, offering a diverse range of opportunities. It
          serves as an ideal investment approach for investors seeking
          short-term returns and who are prepared to embrace higher risks.
        </Text>
      </SummarySection>

      <Divider />

      <HoldingsSection>
        <HoldingsTitle>
          Holdings
          <Tooltip
            value={ALL_HOLDINGS_TOOLTIP}
            placement="top"
            tooltipClassName="v2-tooltip"
          >
            <img src={HelpIconGrey} alt="Help" />
          </Tooltip>
        </HoldingsTitle>
        {/* showPagination only hides the controls -- the table still paginates
            at PAGE_SIZE, which cut the list off at 16 rows (PG-2758). */}
        <Table
          data={holdingsData}
          columns={columns}
          initialPageSize={Math.max(holdingsData.length, 1)}
          showPagination={false}
          showEntriesText={false}
        />
      </HoldingsSection>
    </Modal>
  );
};

AllHoldingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  holdings: PropTypes.arrayOf(
    PropTypes.shape({
      company_name: PropTypes.string,
      asset: PropTypes.string,
      share_price: PropTypes.number,
      performance_1y_percent: PropTypes.number,
      industry: PropTypes.string,
    })
  ),
  strategyName: PropTypes.string,
};

export default AllHoldingsModal;
